import type { DeepString } from "@/lib/i18n";

export const pl = {
  readMore: "Zobacz",
  showAll: "Wszystkie realizacje",
  defaultTitle: "Zobacz inne realizacje",
} as const;

export type WLatestRealizationsTranslations = DeepString<typeof pl>;
